const lists = {
  errors: {
    required: "Campo obligatorio",
    invalidEmail: "Ingresa correo valido",
    invalidPhone: "Ingresa teléfono inválido",
    documentType: "Selecciona un tipo de documento",
    documentNum: "Ingresa un número de documento",
    gender: "Selecciona un género",
    state: "Selecciona un departamento",
    counties: "Selecciona un municipio",
    eps: "Selecciona una EPS",
    headquarter: "Selecciona una sede",
    pqrType: "Selecciona un tipo de PQR",
    whoResides: "Selecciona un tipo de persona",
    service: "Selecciona un servicio",
    description: "Ingresa una descripción",
    files1: "Solo puedes adjuntar un máximo de 5 archivos",
    files2: "solo se admiten archivos de tipo: .docx/pdf/jpg/png",
    files3: "el archivo debe tener un peso máximo de 5Mb",
  },

  form: {
    title: "NUEVA PQRSF",
    subtitle:
      "Por favor complete la información requerida para iniciar con la gestión de su PQRSF",
  },

  searchPqr: {
    title: "ESTADO DE PQRSF",
    subTitle:
      " Ingresa número de radicado para visualizar el estado de tu PQRSF.",
    button: "Nueva PQRSF",
  },

  pqrCard: {
    status: {
      1: "Enviado",
      2: "En gestión",
      3: "Solucionado ",
    },
    ticket_id: "Número de radicado",
    ticket_date: "Fecha de radicado",
    ticket_response: "Fecha de respuesta",
  },

  modal: {
    ticket_id: "Número de radicado",
    petitionMsg1:
      "Te hemos enviado un correo electrónico con los detalles de la Petición realizada.",
    petitionMsg2: "Daremos respuesta en un tiempo no mayor a 48 horas hábiles",
    petitionMsg3: "Su Petición se ha enviado con éxito!",
    pqrMsg1:
      "Te hemos enviado un correo electrónico con los detalles de la PQRSF realizada.",
    pqrMsg2: "Daremos respuesta en un tiempo no mayor a 9 días hábiles",
    pqrMsg3: "Su PQRSF se ha enviado con éxito!",
    errorMsg1: "Estamos trabajando en lo sucedido,",
    errorMsg2: "Intenta gestionar tu PQRS mas tarde",
    errorMsg3: "lo estamos solucionando...",
    errorMsg4: "La gestión de PQRSF no se pudo realizar",
  },

  pqrTypeMsg: {
    petition: {
      title: "PETICIÓN",
      text: "Solicitud formal que realiza cualquier persona ante cualquier autoridad.",
    },
    claim: {
      title: "RECLAMO",
      text: "Exigir o demandar solución referente a la atención inadecuada u omisión de la prestación del servicio.",
    },
    complaint: {
      title: "QUEJA",
      text: "Escrito a través del cual se pone de manifiesto la insatisfacción de un usuario en relación con el servicio recibido.",
    },
    request: {
      title: "SOLICITUD",
      text: "Es la manera en la que el usuario solicita información o respuesta a una duda que tenga de un proceso, servicio o de información en general.",
    },
    suggestion: {
      title: "SUGERENCIA",
      text: "Consejo o propuesta que realiza un paciente o usuario para el mejoramiento de los servicios de la clínica.",
    },
    congratulations: {
      title: "FELICITACIONES",
      text: "Expresión de satisfacción, agradecimiento o similar, en la que se enfatiza la buena labor y se estimula a continuar en la misma tónica.",
    },
  },

  pqrTypeTitle: {
    Reclamo: "RECLAMO",
    Queja: "QUEJA",
    Solicitud: "SOLICITUD",
    Sugerencia: "SUGERENCIA",
    Felicitaciones: "FELICITACIONES",
    Petición: "PETICIÓN",
  },

  date: {
    months: [
      "Ene.",
      "Feb.",
      "Mar.",
      "Abr.",
      "May.",
      "Jun.",
      "Jul.",
      "Ago.",
      "Sep.",
      "Oct.",
      "Nov.",
      "Dic.",
    ],
    days: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ],
  },
}

export default lists
